export const NAME = 'appointmentNotes';